import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";

export interface AguinaldoListItem {
  personId: number;
  fullName: string;
  dni: string;
  baseSalary: number;
  accumulatedAmount: number;
}

export interface AguinaldoMonthly {
  year: number;
  month: number;
  monthLabel: string;
  /** Monto efectivo del mes: el manual si existe, si no el calculado. */
  salarioOrdinario: number;
  /** Lo que calcula el sistema desde planillas / salarios administrativos. */
  salarioOrdinarioCalculado: number;
  /** Override manual guardado para el mes; null si el mes va por cálculo. */
  salarioOrdinarioManual: number | null;
  maternidadPaternidad: number;
  globalDeductions: number;
  totalMensual: number;
}

export interface AguinaldoDetail {
  personId: number;
  fullName: string;
  positionName: string;
  baseSalary: number;
  periodStart: string;
  periodEnd: string;
  months: AguinaldoMonthly[];
  totalOrdinary: number;
  totalMaternidad: number;
  grandTotal: number;
  aguinaldoBruto: number;
  globalDeductions: number;
  pensionQuantity: number;
  pensionUnitAmount: number;
  netToPay: number;
}

export interface AguinaldoEntrySavePayload {
  personId: number;
  year: number;
  month: number;
  /** null limpia el override y devuelve el mes al monto calculado. */
  salarioOrdinarioManual: number | null;
  maternidadPaternidad: number;
  globalDeductions: number;
  pensionQuantity: number;
  pensionUnitAmount: number;
  user: string;
}

export const getAguinaldoList = async (
  year: number,
  filter?: string
): Promise<AguinaldoListItem[]> => {
  try {
    const params: Record<string, string | number> = { year };
    if (filter && filter.trim().length > 0) {
      params.filter = filter.trim();
    }
    const response = await privateFetch.get(URL.AGUINALDO_LIST, { params });
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getAguinaldoDetail = async (
  personId: number,
  year: number
): Promise<AguinaldoDetail> => {
  try {
    const response = await privateFetch.get(URL.AGUINALDO_DETAIL(personId), {
      params: { year },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const saveAguinaldoEntry = async (
  payload: AguinaldoEntrySavePayload
): Promise<void> => {
  try {
    await privateFetch.post(
      URL.AGUINALDO_ENTRY,
      JSON.stringify(payload),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message
        ? error.response.data.message
        : "No se pudo guardar la entrada de aguinaldo"
    );
  }
};
